import { apiClient } from './api-client';

export interface AITranslationTokens {
  access_token: string;
  refresh_token?: string;
  expires_in?: number;
  token_type?: string;
}

export interface TranslationQuestion {
  id: number | string;
  text: string;
  options?: Array<{
    id: string;
    text: string;
  }>;
}

export interface TranslationResult {
  questions: Array<{
    id: number | string;
    text: string;
    options?: Array<{
      id: string;
      text: string;
    }>;
  }>;
  batches_processed?: number;
  batches_successful?: number;
  batches_failed?: number;
  total_saved?: number;
  errors?: Array<{
    batch?: number;
    error: string;
  }>;
  has_errors?: boolean;
  warning?: string;
  request_id?: string;
}

export interface CreditEstimation {
  word_count: number;
  credits_needed: number;
}

export const aiTranslationService = {
  /**
   * Authenticate with AI Translation API
   */
  async authenticate(username: string, password: string, formId: number): Promise<AITranslationTokens> {
    return apiClient.callProxy('aITranslation', 'authenticate', {
      formId,
      username,
      password,
    });
  },

  /**
   * Refresh access token
   */
  async refreshToken(refreshToken: string, formId: number): Promise<AITranslationTokens> {
    return apiClient.callProxy('aITranslation', 'refreshToken', {
      formId,
      refresh_token: refreshToken,
    });
  },

  /**
   * Translate form fields using AI Translation
   */
  async translate(
    integrationId: number,
    targetLanguage: string,
    questions: TranslationQuestion[],
    formId: number
  ): Promise<TranslationResult> {
    return apiClient.callProxy('aITranslation', 'translate', {
      formId,
      integration_id: integrationId,
      target_language: targetLanguage,
      questions,
    });
  },

  /**
   * Estimate AI credits needed for translation
   */
  async estimateCredits(questions: TranslationQuestion[], formId: number): Promise<CreditEstimation> {
    return apiClient.callProxy('aITranslation', 'estimateCredits', {
      formId,
      questions,
    });
  },

  /**
   * Test AI Translation connection
   */
  async testConnection(accessToken: string, formId: number): Promise<{ success: boolean; message: string }> {
    return apiClient.callProxy('aITranslation', 'testConnection', {
      formId,
      access_token: accessToken,
    });
  },
};

